document.addEventListener("DOMContentLoaded", function () {
  // Get elements
  var sizeChartOverlay = document.querySelector(".size-chart-overlay");
  var sizeChart = document.querySelector(".size-chart");
  var convertToInBtn = document.querySelector(".convert-to-in");
  var convertToCmBtn = document.querySelector(".convert-to-cm");
  var convertUnits = document.querySelectorAll(".convert-unit");

  // Initial setup
  var defaultUnit = sizeChart.getAttribute("data-default-unit");
  if (defaultUnit === "cm") {
    convertToCmBtn.classList.add("active");
    convertToInBtn.classList.remove("active");
    convertUnits.forEach(function (unit) {
      unit.classList.toggle("cm", true);
      unit.dataset.originalValue = unit.textContent; // Store the original value
      unit.textContent = convertToCm(unit.textContent);
    });
  }

  // Function to convert range values to centimeters
  function convertToCm(value) {
    var range = value.split("-");
    var lowerValue = parseFloat(range[0]) * 2.54;
    var upperValue = parseFloat(range[1]) * 2.54;
    return lowerValue.toFixed(2) + "-" + upperValue.toFixed(2);
  }

  // Function to revert back to the original format
  function revertToOriginalFormat(value) {
    return value.dataset.originalValue;
  }

  // Event listeners
  convertToCmBtn.addEventListener("click", function () {
    convertToCmBtn.classList.add("active");
    convertToInBtn.classList.remove("active");
    sizeChart.setAttribute("data-default-unit", "cm");
    convertUnits.forEach(function (unit) {
      unit.classList.toggle("cm", true);
      unit.dataset.originalValue = unit.textContent;
      unit.textContent = convertToCm(unit.textContent);
    });
  });

  convertToInBtn.addEventListener("click", function () {
    convertToInBtn.classList.add("active");
    convertToCmBtn.classList.remove("active");
    sizeChart.setAttribute("data-default-unit", "in");
    convertUnits.forEach(function (unit) {
      unit.classList.toggle("cm", false);
      unit.textContent = revertToOriginalFormat(unit);
    });
  });

  document
    .querySelector(".size-chart-toggle-btn")
    .addEventListener("click", function () {
      sizeChartOverlay.classList.add("active");
      sizeChart.classList.add("active");
      document.documentElement.style.overflow = "hidden";
    });

  document
    .querySelector(".size-chart-close")
    .addEventListener("click", function () {
      sizeChartOverlay.classList.remove("active");
      sizeChart.classList.remove("active");
      document.documentElement.style.overflow = "auto";
    });

  sizeChartOverlay.addEventListener("click", function () {
    sizeChartOverlay.classList.remove("active");
    sizeChart.classList.remove("active");
    document.documentElement.style.overflow = "auto";
  });
});
